module.exports = __webpack_public_path__ + "img/marmol.6b96c3c6.jpg";